import { c as _c } from "react/compiler-runtime";
import { IcoCar24, IcoGreenCard24, IcoIdCard24, IcoPassport24, IcoPassportCard24, IcoSsnCard24, IcoVisaPassport24, IcoVoter24, IcoWork24, IcoWriting24 } from '@onefootprint/icons';
import { SupportedIdDocTypes } from '@onefootprint/types/src/data/id-doc-type';
import type { RadioSelectOptionFields } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
const useOptionsByDocType = supportedDocumentTypes => {
  const $ = _c(56);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "document-flow.id-doc.pages.country-and-type-selection"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t0);
  let optionsByDocType;
  if ($[1] !== supportedDocumentTypes || $[2] !== t) {
    optionsByDocType = {};
    if (supportedDocumentTypes?.includes(SupportedIdDocTypes.passport)) {
      let t1;
      if ($[4] !== t) {
        t1 = t(_temp);
        $[4] = t;
        $[5] = t1;
      } else {
        t1 = $[5];
      }
      let t2;
      if ($[6] !== t1) {
        t2 = {
          title: t1,
          IconComponent: IcoPassport24,
          value: SupportedIdDocTypes.passport
        };
        $[6] = t1;
        $[7] = t2;
      } else {
        t2 = $[7];
      }
      optionsByDocType[SupportedIdDocTypes.passport] = t2;
    }
    if (supportedDocumentTypes?.includes(SupportedIdDocTypes.driversLicense)) {
      let t1;
      if ($[8] !== t) {
        t1 = t(_temp2);
        $[8] = t;
        $[9] = t1;
      } else {
        t1 = $[9];
      }
      let t2;
      if ($[10] !== t1) {
        t2 = {
          title: t1,
          IconComponent: IcoCar24,
          value: SupportedIdDocTypes.driversLicense
        };
        $[10] = t1;
        $[11] = t2;
      } else {
        t2 = $[11];
      }
      optionsByDocType[SupportedIdDocTypes.driversLicense] = t2;
    }
    if (supportedDocumentTypes?.includes(SupportedIdDocTypes.idCard)) {
      let t1;
      if ($[12] !== t) {
        t1 = t(_temp3);
        $[12] = t;
        $[13] = t1;
      } else {
        t1 = $[13];
      }
      let t2;
      if ($[14] !== t1) {
        t2 = {
          title: t1,
          IconComponent: IcoIdCard24,
          value: SupportedIdDocTypes.idCard
        };
        $[14] = t1;
        $[15] = t2;
      } else {
        t2 = $[15];
      }
      optionsByDocType[SupportedIdDocTypes.idCard] = t2;
    }
    if (supportedDocumentTypes?.includes(SupportedIdDocTypes.visa)) {
      let t1;
      if ($[16] !== t) {
        t1 = t(_temp4);
        $[16] = t;
        $[17] = t1;
      } else {
        t1 = $[17];
      }
      let t2;
      if ($[18] !== t1) {
        t2 = {
          title: t1,
          IconComponent: IcoVisaPassport24,
          value: SupportedIdDocTypes.visa
        };
        $[18] = t1;
        $[19] = t2;
      } else {
        t2 = $[19];
      }
      optionsByDocType[SupportedIdDocTypes.visa] = t2;
    }
    if (supportedDocumentTypes?.includes(SupportedIdDocTypes.workPermit)) {
      let t1;
      if ($[20] !== t) {
        t1 = t(_temp5);
        $[20] = t;
        $[21] = t1;
      } else {
        t1 = $[21];
      }
      let t2;
      if ($[22] !== t1) {
        t2 = {
          title: t1,
          IconComponent: IcoWork24,
          value: SupportedIdDocTypes.workPermit
        };
        $[22] = t1;
        $[23] = t2;
      } else {
        t2 = $[23];
      }
      optionsByDocType[SupportedIdDocTypes.workPermit] = t2;
    }
    if (supportedDocumentTypes?.includes(SupportedIdDocTypes.residenceDocument)) {
      let t1;
      if ($[24] !== t) {
        t1 = t(_temp6);
        $[24] = t;
        $[25] = t1;
      } else {
        t1 = $[25];
      }
      let t2;
      if ($[26] !== t1) {
        t2 = {
          title: t1,
          IconComponent: IcoGreenCard24,
          value: SupportedIdDocTypes.residenceDocument
        };
        $[26] = t1;
        $[27] = t2;
      } else {
        t2 = $[27];
      }
      optionsByDocType[SupportedIdDocTypes.residenceDocument] = t2;
    }
    if (supportedDocumentTypes?.includes(SupportedIdDocTypes.voterIdentification)) {
      let t1;
      if ($[28] !== t) {
        t1 = t(_temp7);
        $[28] = t;
        $[29] = t1;
      } else {
        t1 = $[29];
      }
      let t2;
      if ($[30] !== t1) {
        t2 = {
          title: t1,
          IconComponent: IcoVoter24,
          value: SupportedIdDocTypes.voterIdentification
        };
        $[30] = t1;
        $[31] = t2;
      } else {
        t2 = $[31];
      }
      optionsByDocType[SupportedIdDocTypes.voterIdentification] = t2;
    }
    if (supportedDocumentTypes?.includes(SupportedIdDocTypes.ssnCard)) {
      let t1;
      if ($[32] !== t) {
        t1 = t(_temp8);
        $[32] = t;
        $[33] = t1;
      } else {
        t1 = $[33];
      }
      let t2;
      if ($[34] !== t1) {
        t2 = {
          title: t1,
          IconComponent: IcoSsnCard24,
          value: SupportedIdDocTypes.ssnCard
        };
        $[34] = t1;
        $[35] = t2;
      } else {
        t2 = $[35];
      }
      optionsByDocType[SupportedIdDocTypes.ssnCard] = t2;
    }
    if (supportedDocumentTypes?.includes(SupportedIdDocTypes.lease)) {
      let t1;
      if ($[36] !== t) {
        t1 = t(_temp9);
        $[36] = t;
        $[37] = t1;
      } else {
        t1 = $[37];
      }
      let t2;
      if ($[38] !== t1) {
        t2 = {
          title: t1,
          IconComponent: IcoWriting24,
          value: SupportedIdDocTypes.lease
        };
        $[38] = t1;
        $[39] = t2;
      } else {
        t2 = $[39];
      }
      optionsByDocType[SupportedIdDocTypes.lease] = t2;
    }
    if (supportedDocumentTypes?.includes(SupportedIdDocTypes.bankStatement)) {
      let t1;
      if ($[40] !== t) {
        t1 = t(_temp10);
        $[40] = t;
        $[41] = t1;
      } else {
        t1 = $[41];
      }
      let t2;
      if ($[42] !== t1) {
        t2 = {
          title: t1,
          IconComponent: IcoWriting24,
          value: SupportedIdDocTypes.bankStatement
        };
        $[42] = t1;
        $[43] = t2;
      } else {
        t2 = $[43];
      }
      optionsByDocType[SupportedIdDocTypes.bankStatement] = t2;
    }
    if (supportedDocumentTypes?.includes(SupportedIdDocTypes.utilityBill)) {
      let t1;
      if ($[44] !== t) {
        t1 = t(_temp11);
        $[44] = t;
        $[45] = t1;
      } else {
        t1 = $[45];
      }
      let t2;
      if ($[46] !== t1) {
        t2 = {
          title: t1,
          IconComponent: IcoWriting24,
          value: SupportedIdDocTypes.utilityBill
        };
        $[46] = t1;
        $[47] = t2;
      } else {
        t2 = $[47];
      }
      optionsByDocType[SupportedIdDocTypes.utilityBill] = t2;
    }
    if (supportedDocumentTypes?.includes(SupportedIdDocTypes.proofOfAddress)) {
      let t1;
      if ($[48] !== t) {
        t1 = t(_temp12);
        $[48] = t;
        $[49] = t1;
      } else {
        t1 = $[49];
      }
      let t2;
      if ($[50] !== t1) {
        t2 = {
          title: t1,
          IconComponent: IcoWriting24,
          value: SupportedIdDocTypes.proofOfAddress
        };
        $[50] = t1;
        $[51] = t2;
      } else {
        t2 = $[51];
      }
      optionsByDocType[SupportedIdDocTypes.proofOfAddress] = t2;
    }
    if (supportedDocumentTypes?.includes(SupportedIdDocTypes.passportCard)) {
      let t1;
      if ($[52] !== t) {
        t1 = t(_temp13);
        $[52] = t;
        $[53] = t1;
      } else {
        t1 = $[53];
      }
      let t2;
      if ($[54] !== t1) {
        t2 = {
          title: t1,
          IconComponent: IcoPassportCard24,
          value: SupportedIdDocTypes.passportCard
        };
        $[54] = t1;
        $[55] = t2;
      } else {
        t2 = $[55];
      }
      optionsByDocType[SupportedIdDocTypes.passportCard] = t2;
    }
    $[1] = supportedDocumentTypes;
    $[2] = t;
    $[3] = optionsByDocType;
  } else {
    optionsByDocType = $[3];
  }
  return optionsByDocType;
};
export default useOptionsByDocType;
function _temp($) {
  return $.form.type.passport.title;
}
function _temp2($_0) {
  return $_0.form.type.driversLicense.title;
}
function _temp3($_1) {
  return $_1.form.type.idCard.title;
}
function _temp4($_2) {
  return $_2.form.type.visa.title;
}
function _temp5($_3) {
  return $_3.form.type.workPermit.title;
}
function _temp6($_4) {
  return $_4.form.type.residenceDocument.title;
}
function _temp7($_5) {
  return $_5.form.type.voterIdentification.title;
}
function _temp8($_6) {
  return $_6.form.type.ssnCard.title;
}
function _temp9($_7) {
  return $_7.form.type.lease.title;
}
function _temp10($_8) {
  return $_8.form.type.bankStatement.title;
}
function _temp11($_9) {
  return $_9.form.type.utilityBill.title;
}
function _temp12($_10) {
  return $_10.form.type.proofOfAddress.title;
}
function _temp13($_11) {
  return $_11.form.type.passportCard.title;
}